// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-body svg{
  font-size: 16px;
}

.normal-box{
  padding: 10px;
  text-align: left;
  box-shadow: 0px 0px 4px #e7e7e7;
  margin: 20px 0;
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 90%;
}

.normal-box span{
  font-size: 13px;
  font-family: 'Montserrat', sans-serif;
  color: #818181;
  display: block;
}

.basic-info .form-group{
  margin-bottom: 20px;
}

.basic-info form label {
  color: #818181;
  position: absolute;
  padding: 10px;
  font-size: 12px;
  z-index: 1;
}

.basic-info form input {
  padding-top: 1.825rem;
  padding-bottom: 0.625rem;
}

.basic-info form .react-dropdown-select-option + input {
  padding-top: 0;
}

.pos-relative{
  position: relative!important;
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-radio .custom-control-input:checked~.custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.basic-info label.no-style{
  padding: 0;
  font-size: 16px;
  position: relative;
}

.react-datepicker-wrapper{
  display: block !important;
}

.react-datepicker-wrapper{
  z-index: 9 !important;
}

.select-box .select-multi{
  padding-top: 1.825rem!important;
  padding-bottom: 0.625rem!important;
}

.css-13cymwt-control{
  border-style: none!important;
}
.css-3w2yfm-ValueContainer{
  padding: 0!important;
}
.css-1hb7zxy-IndicatorsContainer .css-1xc3v61-indicatorContainer:nth-child(1){
  display: none!important;
}
.sp-notes{
  position: relative;
  z-index: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/BasicInformation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;IACd,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;EACE,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yDAAqJ;AACvJ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ","sourcesContent":[".app-body svg{\r\n  font-size: 16px;\r\n}\r\n\r\n.normal-box{\r\n  padding: 10px;\r\n  text-align: left;\r\n  box-shadow: 0px 0px 4px #e7e7e7;\r\n  margin: 20px 0;\r\n  overflow: hidden;\r\n    white-space: nowrap;\r\n    text-overflow: ellipsis;\r\n    width: 90%;\r\n}\r\n\r\n.normal-box span{\r\n  font-size: 13px;\r\n  font-family: 'Montserrat', sans-serif;\r\n  color: #818181;\r\n  display: block;\r\n}\r\n\r\n.basic-info .form-group{\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.basic-info form label {\r\n  color: #818181;\r\n  position: absolute;\r\n  padding: 10px;\r\n  font-size: 12px;\r\n  z-index: 1;\r\n}\r\n\r\n.basic-info form input {\r\n  padding-top: 1.825rem;\r\n  padding-bottom: 0.625rem;\r\n}\r\n\r\n.basic-info form .react-dropdown-select-option + input {\r\n  padding-top: 0;\r\n}\r\n\r\n.pos-relative{\r\n  position: relative!important;\r\n}\r\n\r\n.custom-radio .custom-control-label::before {\r\n  border-radius: 50%;\r\n}\r\n\r\n.custom-control-inline {\r\n  display: inline-flex;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.custom-radio .custom-control-input:checked~.custom-control-label::after {\r\n  background-image: url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e);\r\n}\r\n\r\n.basic-info label.no-style{\r\n  padding: 0;\r\n  font-size: 16px;\r\n  position: relative;\r\n}\r\n\r\n.react-datepicker-wrapper{\r\n  display: block !important;\r\n}\r\n\r\n.react-datepicker-wrapper{\r\n  z-index: 9 !important;\r\n}\r\n\r\n.select-box .select-multi{\r\n  padding-top: 1.825rem!important;\r\n  padding-bottom: 0.625rem!important;\r\n}\r\n\r\n.css-13cymwt-control{\r\n  border-style: none!important;\r\n}\r\n.css-3w2yfm-ValueContainer{\r\n  padding: 0!important;\r\n}\r\n.css-1hb7zxy-IndicatorsContainer .css-1xc3v61-indicatorContainer:nth-child(1){\r\n  display: none!important;\r\n}\r\n.sp-notes{\r\n  position: relative;\r\n  z-index: 0;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
